import React, {useState } from 'react';
import './PaymentFailure.css';
import failuregif from '../../Images/paymentfailed.gif';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';



const PaymentFailure = ({ error_message, toredirect }) => {
  const ref = React.createRef();
  const navigate=useNavigate();
  const [isopen,setIsopen]=useState(true);

  const onRetry = () => {
    if (toredirect === "2") {
      showme();
      navigate(`/success/Pay-Online`);
    } else if (toredirect === "1") {
      showme();
      navigate(`/success/account-statement`);
    }
  };
  const showme=()=>{
    setIsopen(false);
  }

  return (
    
      isopen && <div className="payment-failure-container">
        <div className="payment-failure-message" ref={ref}>
          <h3>Payment Failed !</h3>
          <img src={failuregif} alt="payment-failure-gif" className="payment-failure-gif" style={{ marginTop: '0vw' }} />
          <p>
            {error_message
              ? `Unfortunately, ${error_message} Please try again later.`
              : "Your payment could not be processed due to technical issue. Please try again later."
            }
          </p>
          <button className="retry-button" onClick={onRetry}>
            Cancel
          </button>
        </div>
      </div>
     
  );
};

PaymentFailure.propTypes = {
  error_message: PropTypes.string, 
  toredirect:PropTypes.string

};
export default PaymentFailure;